import HttpService from "./../constant/Api";

export const sendToken = (token) => {
  return HttpService.post(`v2/notifications/push/tokens`, {
    token: token,
    type: `WEB`,
    deviceId: `ID-${token}`,
  });
};
